import useTrailingStop from "@shared/features/tradingTerminal/SmartTrade/useTrailingStop";
import React, { useContext } from "react";
import { WebTradingTerminalContext } from "features/tradingTerminal/WebTradingTerminal.context";

const TrailingStop = () => {
  const { trailingComponent, trailingModifiedConfiguration } = useContext(
    WebTradingTerminalContext
  )!;

  useTrailingStop(trailingModifiedConfiguration);

  return <div style={{ paddingTop: 8 }}>{trailingComponent}</div>;
};

export default TrailingStop;
